import React, { HTMLAttributes, memo, useMemo } from 'react';
import { Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { treatSearch } from '@utils/searchHistoryMenu';

import './styles.less';

interface IDeviceActionsMenuProps extends HTMLAttributes<HTMLElement> {
  onSearchClick: (value: string) => void;
  searchHistory: string[];
  showHistory: boolean;
}
const DeviceHistoryMenu: React.FC<IDeviceActionsMenuProps> = ({
  onSearchClick,
  className,
  searchHistory,
  showHistory,
  children,
}) => {
  const { t } = useTranslation('inventory-detailed');

  const items: MenuProps['items'] = useMemo(
    () => [
      {
        key: 'history',
        type: 'group',
        label: t('device-query.search-history'),
        children: searchHistory
          ?.map((option: string) => {
            const optionType = treatSearch(option).type;
            const labelType =
              optionType === 'nickname'
                ? `${t('device-query.nickname')}: `
                : `${optionType}: `;
            return {
              key: option,
              className: 'menu-item',
              onClick: ({ key }: { key: string }) => {
                onSearchClick(key);
              },
              label: (
                <>
                  <span>{labelType}</span>
                  <strong>{option}</strong>
                </>
              ),
            };
          })
          ?.reverse(),
      },
    ],
    [onSearchClick, searchHistory, t],
  );

  if (searchHistory?.length > 0 && showHistory) {
    return (
      <Dropdown
        overlayClassName="overlay-menu"
        menu={{ items }}
        className={className}
        trigger={['click']}
      >
        {children}
      </Dropdown>
    );
  }

  return <>{children}</>;
};

export default memo(DeviceHistoryMenu);
